// Runtime webpack config
import '../../other/WebpackConfig';

// i18n
import i18n from '../../i18n/nl-BE';

import popularKeyword from './popularKeyword';

// Tenant-specific styles
import '../../../scss/popularKeywordPage/popularKeyword.twh.nlbe.scss';

popularKeyword(i18n);
